<template>
  <div class="select-material">
    <NavHeaderBar :navBarTitle="$t('form.sampleDelivery')" :showSearch="false" />
    <div v-show="!showSearch">

      <!-- Filter Section -->
      <div class="filter-section">
        <div class="dropdown-trigger" @click="showFilter = !showFilter">
          <span class="label">{{ currentFilterLabel }}</span>
          <van-icon name="play" class="arrow-icon" :class="{ expanded: showFilter }" />
        </div>
        <van-icon name="search" class="search-icon" size="20" @click="handleSearch" />
      </div>
    </div>

    <!-- Search Bar -->
    <div v-show="showSearch" class="search-bar-wrapper">
      <van-search
        v-model="searchVal"
        show-action
        :placeholder="`${$t('button.search')}...`"
        @input="onSearch"
        @cancel="onCancelSearch"
      />
    </div>

    <!-- Filter Popup -->
    <van-popup v-model="showFilter" position="bottom" round safe-area-inset-bottom>
      <div class="filter-popup-content">
        <div class="filter-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-options">
          <div
            v-for="option in projectList"
            :key="option.id"
            class="filter-tag"
            :class="{ active: currentFilterValue === option.id }"
            @click="selectTempFilter(option)"
          >
            {{ option.projectName }}
          </div>
        </div>
        <div class="filter-actions">
          <van-button block class="reset-btn" @click="resetFilter">{{ $t('button.reset') }}</van-button>
          <van-button block type="info" class="confirm-btn" @click="confirmFilter">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- List Section -->
    <div class="list-content">
      <div v-for="(item, index) in sampleDeliveryList" :key="index" class="material-item">
        <div class="left-content">
          <img v-if="item.imgUrl" :src="item.imgUrl" class="item-img" @click.stop="imgPreview(item.imgUrl.split(',')[0])" />
          <img v-else src="@/assets/images/icon_noimg.png" class="item-img" />
          <div class="item-info">
            <div class="title-row txt-ellipsis">{{ item.projectName }}·{{ item.productName }}</div>
            <div class="tags-row">
              <span class="inventory">{{ $t('form.inventory') }}: {{ item.inventoryCount }}</span>
            </div>
          </div>
        </div>
        <div class="right-content">
          <van-checkbox v-model="item.isChoose" @click="handleCheck(item)" shape="square" />
        </div>
      </div>
      <!-- Empty State -->
      <van-empty v-if="sampleDeliveryList.length === 0" :description="$t('tips.noData')" />
    </div>

    <!-- Footer Action -->
    <div class="footer-action">
      <div class="left-btn" @click="clearSelected">
        <span class="clear-text">{{ $t('button.clearSelected') }}</span>
        <span class="count-text">({{ $t('button.selected') }} {{ currentSelectedListCount }} {{ $t('button.types') }})</span>
        <!-- <span class="count-text" v-else>(Selected {{ selectedCount }} types)</span> -->
      </div>
      <div class="right-btn" @click="confirm">
        {{ $t('button.confirm') }}
      </div>
    </div>
  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import { eventDeliveryProtoListPageApi, eventDeliveryBatchDeliveryProtoApi } from '@/api/shared'
import { arsProductInventoryListApi } from '@/api/storeExpansion'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import { mapState } from 'vuex'
import { Toast, ImagePreview, Notify, Dialog } from 'vant'

export default {
  name: 'SelectMaterial',
  components: {
    NavHeaderBar
  },
  data () {
    return {
      searchVal: '',
      showSearch: false,
      showFilter: false,
      currentFilterValue: '',
      currentFilterLabel: this.$t('shared.filter.brand'),
      sampleDeliveryList: [], // All data
      selectedIds: [], // Store selected IDs
      projectList: [],
      pageType: '',
      currentSelectedList: []
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    ...mapState({
      globalData: 'globalData'
    }),
    selectedCount () {
      return this.sampleDeliveryList.filter(item => item.isChoose).length
    },
    currentSelectedListCount () {
      return this.currentSelectedList.filter(item => item.isChoose).length
    }
  },
  activated () {
    this.pageType = this.$route.query.pageType
    this.currentSelectedList = []
    this.resetFilter()
    this.onCancelSearch()
    if (['expandVisit', 'visit', 'reorder'].includes(this.pageType)) {
      const sampleDelivery = JSON.parse(window.localStorage.getItem('sampleDelivery'))
      this.currentSelectedList = sampleDelivery || []
    }
    this.sampleDeliveryList = []
    this.projectList = []
    this.initData()
  },
  methods: {
    initData () {
      arsProjectAppQueryListApi().then(res => {
        this.projectList = res.data
      })
      if (['expandVisit', 'visit', 'reorder'].includes(this.pageType)) {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        const data = {
          productName: this.searchVal,
          projectId: this.currentFilterValue
        }
        arsProductInventoryListApi(data).then(res => {
          Toast.clear()
          res.data.forEach(subItem => {
            subItem.isChoose = false
            subItem.quantity = ''
            subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
          })
          this.sampleDeliveryList = res.data || []
          if (this.currentSelectedList) {
            this.currentSelectedList.forEach(subItem => {
              this.sampleDeliveryList.find(materItem => {
                if (subItem.productId === materItem.productId) {
                  materItem.quantity = subItem.quantity
                  materItem.isChoose = true
                  materItem.inventoryCount = Number(subItem.inventoryCount) || 0
                  return materItem
                }
              })
            })
          }
        })
      } else {
        const data = {
          eventId: this.eventInfo.eventId,
          projectId: this.currentFilterValue,
          page: 1,
          limit: 1000,
          protoName: this.searchVal
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        eventDeliveryProtoListPageApi(data).then(res => {
          Toast.clear()
          const newList = res.data.filter(subItem => subItem.isChoose)
          newList.forEach(subItem => {
            // 用 id 判断 currentSelectedList 中是否已存在
            const exists = this.currentSelectedList.find(
              item => item.protoId === subItem.protoId
            )

            if (!exists) {
              this.currentSelectedList.push(subItem)
            }
          })
          this.sampleDeliveryList = res.data || []
        })
      }
    },
    selectTempFilter (option) {
      this.currentFilterValue = option.id
      this.currentFilterLabel = option.projectName
    },
    resetFilter () {
      this.currentFilterValue = ''
      this.currentFilterLabel = this.$t('shared.filter.brand')
    },
    confirmFilter () {
      this.showFilter = false
      this.initData()
    },
    handleCheck (item) {
      // Checkbox v-model handles the toggle, this is for extra logic if needed
      if (item.isChoose) {
        this.currentSelectedList.push(item)
      } else {
        if (this.currentSelectedList.length <= 0) {
          this.currentSelectedList.push(item)
        } else {
          if (['expandVisit', 'visit', 'reorder'].includes(this.pageType)) {
            this.currentSelectedList = this.currentSelectedList.filter(subItem => {
              return subItem.productId !== item.productId
            })
          } else {
            this.currentSelectedList = this.currentSelectedList.filter(subItem => {
              return subItem.protoId !== item.protoId
            })
          }
        }
      }
    },
    clearSelected () {
      Dialog.confirm({
        message: this.$t('tips.messageThirtySeven'),
        confirmButtonText: this.$t('button.clear'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#d9001b'
      })
        .then(() => {
          this.sampleDeliveryList.forEach((item) => {
            item.isChoose = false
          })
          this.currentSelectedList = []
          if (!['expandVisit', 'visit', 'reorder'].includes(this.pageType)) {
            this.confirm()
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    confirm () {
      if (['expandVisit', 'visit', 'reorder'].includes(this.pageType)) {
        const sampleDelivery = this.currentSelectedList.filter(item => item.isChoose)
        window.localStorage.setItem('sampleDelivery', JSON.stringify(sampleDelivery))
        this.$router.go(-1)
      } else {
        const data = {
          eventId: this.eventInfo.eventId,
          protoIdList: this.currentSelectedList.filter(item => item.isChoose).map(item => item.protoId)
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        eventDeliveryBatchDeliveryProtoApi(data).then(res => {
          Toast.clear()
          Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
          this.$router.go(-1)
        })
      }
    },
    onSearch () {
      // Triggered by search enter
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.initData()
      }, 500)
    },
    onCancelSearch () {
      this.showSearch = false
      this.searchVal = ''
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    handleSearch () {
      this.showSearch = true
      this.$nextTick(() => {
      // this.$refs.searchRef.focus()
        this.$el.querySelector('.van-field__control').focus()
        // this.$refs.searchRef.querySelector('input').focus()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.select-material {
  min-height: 100vh;
  background-color: #fff;
  padding-bottom: 60px; // space for footer

  .filter-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background: #fff;
    border-bottom: 1px solid #eee;
    position: relative;
    z-index: 101; // Above popup

    .dropdown-trigger {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #333;
      cursor: pointer;

      .arrow-icon {
        font-size: 12px;
        margin-left: 6px;
        transform: rotate(90deg);
        transition: transform 0.2s;
        &.expanded {
          transform: rotate(-90deg);
        }
      }
    }

    .search-icon {
      color: #999;
      cursor: pointer;
    }
  }

  .search-bar-wrapper {
    background: #f7f8fa;
  }

  .list-content {
    padding: 0 16px;

    .material-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #eee;

      .left-content {
        display: flex;
        align-items: flex-start;
        flex: 1;
        margin-right: 10px;

        .item-img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          margin-right: 10px;
        }

        .item-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 40px;

          .title-row {
            display: flex;
            align-items: center;

            .title {
              font-size: 13px;
              color: #333;
              margin-right: 6px;
            }

            .star-icon {
              font-size: 12px;
            }
          }

          .tags-row {
            display: flex;
            align-items: center;
            font-size: 12px;

            .tag {
              max-width: 126px;
              padding: 1px 4px;
              border-radius: 2px;
              margin-right: 8px;
              border: 1px solid #307bff;
              color: #307bff;

              &.universal-name {
                border: 1px solid #34b032;
                color: #34b032;
              }
            }

            .inventory {
              color: #666;
            }
          }
        }
      }

      .right-content {
        // Checkbox style
      }
    }
  }

  .footer-action {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
    background: #fff;
    z-index: 100;

    .left-btn {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #d93026;
      font-size: 14px;
      background: #fff;
      cursor: pointer;

      .clear-text {
        font-weight: bold;
      }
      .count-text {
        font-size: 10px;
      }
    }

    .right-btn {
      flex: 1;
      background: #1989fa;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .filter-popup-content {
    padding: 16px;
    background: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    .filter-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
      color: #333;
    }

    .filter-options {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 30px;
      flex: 1;

      .filter-tag {
        height: 33px;
        line-height: 33px;
        padding: 0px 16px;
        background: #f5f6f8;
        border-radius: 4px;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        min-width: 80px;
        text-align: center;

        &.active {
          background: #e6f1fc;
          color: #1989fa;
          font-weight: 500;
        }
      }
    }

    .filter-actions {
      display: flex;
      gap: 12px;
      margin-top: auto;

      .reset-btn {
        flex: 1;
        background: #ebedf0;
        border: none;
        color: #333;
        border-radius: 6px;
      }

      .confirm-btn {
        flex: 1;
        border-radius: 6px;
      }
    }
  }
}
</style>
